// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18 1H6V6H9.5V8H6V11H11V13H6V16H9.5V18H6V23H18V1Z"}}]};

const MeasurementFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'measurement-filled',
    ref,
    icon: element,
  },
));

MeasurementFilledIcon.displayName = 'MeasurementFilledIcon';

export default MeasurementFilledIcon;
